import { Icons } from "../../../../../../shared/icons/icons";

const LocalArrowRightIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

export const ArrowRightIcon =
  Icons.ArrowRight || Icons.ChevronRight || LocalArrowRightIcon;

export const benefitsContentByMode = {
  all: {
    eyebrow: "Por que Dionara",
    titleMain: "Por que você vai se sentir",
    titleAccent: "diferente aqui?",
    description:
      "Cada detalhe foi pensado para que você se sinta acolhida, segura e acompanhada em todas ",
    descriptionStrong: "as etapas do seu cuidado.",
    commitmentTitle: "Nosso compromisso é com você",
    commitmentAccent: "e com a sua melhor versão.",
    commitmentText:
      "Aqui, ciência, estética, nutrição e acolhimento caminham juntos para cuidar de você por completo.",
    commitmentButton: "Agendar avaliação",
  },

  aesthetics: {
    eyebrow: "Experiência estética",
    titleMain: "Por que sua experiência estética",
    titleAccent: "é diferente aqui?",
    description:
      "Porque cada procedimento é pensado com segurança, naturalidade e acolhimento para realçar sua beleza com equilíbrio.",
    descriptionStrong: "realçar sua beleza com equilíbrio.",
    commitmentTitle: "Nosso compromisso é com você",
    commitmentAccent: "e com a sua autoestima.",
    commitmentText:
      "Aqui, técnica, segurança e sensibilidade caminham juntas para valorizar sua beleza de forma natural.",
    commitmentButton: "Agendar avaliação estética",
  },

  nutrition: {
    eyebrow: "Cuidado nutricional",
    titleMain: "Por que sua jornada nutricional",
    titleAccent: "fica mais leve aqui?",
    description:
      "Porque o plano é construído com escuta, realidade e estratégia para você cuidar da saúde com constância e leveza.",
    descriptionStrong: "cuidar da saúde com constância e leveza.",
    commitmentTitle: "Nosso compromisso é com você",
    commitmentAccent: "e com a sua saúde.",
    commitmentText:
      "Aqui, nutrição, acolhimento e acompanhamento próximo caminham juntos para transformar sua rotina com leveza.",
    commitmentButton: "Agendar consulta nutricional",
  },
};

export const benefitCardsByMode = {
  all: [
    {
      title: "Atendimento humanizado",
      text: "Você é única. Aqui, você é escutada, acolhida e cuidada com atenção de verdade.",
      Icon: Icons.UserHeart,
    },
    {
      title: "Protocolos personalizados",
      text: "Cada plano é construído de acordo com seus objetivos, sua rotina e suas necessidades.",
      Icon: Icons.ClipboardCheck,
    },
    {
      title: "Autoestima, saúde e bem-estar",
      text: "Cuidamos da sua saúde de forma completa, respeitando seu corpo, sua história e o seu processo.",
      Icon: Icons.Flower2,
    },
    {
      title: "Planejamento adaptado",
      text: "Cada etapa é pensada para seu momento, rotina e objetivos.",
      Icon: Icons.Goal,
    },
    {
      title: "Acompanhamento próximo",
      text: "Você não está sozinha: estamos com você do início ao resultado.",
      Icon: Icons.HandHeart,
    },
    {
      title: "Resultados com equilíbrio",
      text: "Buscamos evolução real, natural e sustentável para a sua vida.",
      Icon: Icons.Sparkles,
    },
  ],

  aesthetics: [
    {
      title: "Atendimento acolhedor",
      text: "Você é escutada e orientada com cuidado desde a primeira avaliação.",
      Icon: Icons.UserHeart,
    },
    {
      title: "Procedimentos personalizados",
      text: "Cada protocolo é pensado para sua pele, seus objetivos e sua beleza natural.",
      Icon: Icons.ClipboardCheck,
    },
    {
      title: "Autoestima e bem-estar",
      text: "O foco é realçar sua beleza com leveza, segurança e naturalidade.",
      Icon: Icons.Flower2,
    },
    {
      title: "Planejamento estético",
      text: "Cada etapa é organizada para gerar resultados harmônicos e seguros.",
      Icon: Icons.Goal,
    },
    {
      title: "Acompanhamento próximo",
      text: "Você recebe orientação antes, durante e após o procedimento.",
      Icon: Icons.HandHeart,
    },
    {
      title: "Resultados naturais",
      text: "Realçamos sua melhor versão com equilíbrio e elegância.",
      Icon: Icons.Sparkles,
    },
  ],

  nutrition: [
    {
      title: "Escuta sem julgamento",
      text: "Você é acolhida de forma leve, respeitando sua rotina e sua história.",
      Icon: Icons.UserHeart,
    },
    {
      title: "Plano alimentar personalizado",
      text: "Estratégias adaptadas aos seus objetivos, preferências e realidade.",
      Icon: Icons.ClipboardCheck,
    },
    {
      title: "Saúde com leveza",
      text: "O foco é criar uma relação mais tranquila e sustentável com a alimentação.",
      Icon: Icons.Flower2,
    },
    {
      title: "Metas possíveis",
      text: "Nada de extremos: o plano evolui junto com você, no seu ritmo.",
      Icon: Icons.Goal,
    },
    {
      title: "Acompanhamento próximo",
      text: "Você tem suporte para ajustar a rota e manter constância.",
      Icon: Icons.HandHeart,
    },
    {
      title: "Resultados sustentáveis",
      text: "Mudanças reais, possíveis e pensadas para durar.",
      Icon: Icons.Sparkles,
    },
  ],
};

/* Compatibilidade com código antigo */
export const benefitCards = benefitCardsByMode.all;